import { action, computed, observable, decorate } from 'mobx';
const { GoogleSpreadsheet } = require('google-spreadsheet');

class StateStore {
  BasicDetails = {
    name: '',
    email: '',
    pinCode: '',
    work: '',
    age: '',
  };
  receivedQuestions = [];
  route = 'home';
  selected = '';
  Answers = [];

  finalFunction = async () => {
    const data = this.BasicDetails;
    const creds = require('./surveyqls-2ff18faff3ff.json');
    const doc = new GoogleSpreadsheet(
      '1k3KYpkydRNFnpughl9Amzaq_Cnc_sh3Y-DKgpPFVskQ'
    );
    await doc.useServiceAccountAuth(creds);

    await doc.loadInfo(); // loads document properties and worksheets
    console.log(doc.title);
    const sheet = doc.sheetsByIndex[0];
    console.log(sheet.title);
    console.log('Row Count = ' + sheet.rowCount);
    const addRow = await sheet.addRow({
      Name: `${data.name}`,
      Email: `${data.email}`,
      PinCode: `${data.pinCode}`,
      Work: `${data.work}`,
      Age: `${data.age}`,
      Answers: `${this.Answers}`,
    });
    console.log(addRow);
  };

  changeSelected = (value) => {
    this.selected = value;
  };

  addToReceivedQuestions = (data) => {
    this.receivedQuestions = data;
  };

  get receivedQuestionsCount() {
    return this.receivedQuestions.length;
  }

  addAnswers = () => {
    this.Answers.push(this.selected);
  };

  changeAnswers = (value, i) => {
    this.Answers[i] = value;
  };

  get answersCount() {
    return this.Answers.length;
  }

  changeRoute = (r) => {
    this.route = r;
  };

  addBasicDetails = (n, e, p, w, a) => {
    this.BasicDetails.name = n;
    this.BasicDetails.email = e;
    this.BasicDetails.pinCode = p;
    this.BasicDetails.work = w;
    this.BasicDetails.age = a;
    console.log(this.BasicDetails);
  };
}

decorate(StateStore, {
  BasicDetails: observable,
  addBasicDetails: action,
  route: observable,
  changeRoute: action,
  Answers: observable,
  addAnswers: action,
  answersCount: computed,
  changeAnswers: action,
  receivedQuestions: observable,
  addToReceivedQuestions: action,
  receivedQuestionsCount: computed,
  changeSelected: action,
  selected: observable,
});

const store = new StateStore();
export default store;
